import fetch from '@ixigo/fetch';
import {
	type ApiErrorResponse,
	type BookingStatus,
	executeApiCall,
} from '@/api';

export interface CabBookingMetadata {
	fare: string;
	arrival_time: string;
	seating_capacity: string;
	is_payment_complete: boolean;
	pickup_location: string;
	timezone: string;
	cab_type: string;
	trip_title: string;
	ride_details: string;
	departure_time: string;
	dropoff_location: string;
	luggage_capacity: string;
}

interface CommonBookingInfo {
	userId: string;
	bookedAt: string;
	bookingId: string;
	activityStartTime: string;
	activityEndTime: string;
	status: BookingStatus;
	activityStartTimeInstant: string;
	createdAt: string;
	updatedAt: string;
}

export interface CabUserBooking extends CommonBookingInfo {
	product: 'CAB';
	metadata: CabBookingMetadata;
}

export interface UpcomingTripsResponse {
	data: CabUserBooking[];
}

export type UpcomingTripsApiResponse = UpcomingTripsResponse | ApiErrorResponse;

export const fetchUpcomingTrips =
	async (): Promise<UpcomingTripsApiResponse> => {
		// Detect user's timezone
		const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		const url = `api/profile/secure/booking?upcoming=true&travelWithinDays=7&listingCategory=SUCCESSFUL&formattingCategory=UPCOMING_TRIPS_CARDS&userTimeZone=${encodeURIComponent(userTimeZone)}&limit=10&product=CAB&status=CONFIRMED`;

		return executeApiCall(
			() => fetch.get<UpcomingTripsResponse>(url).json(),
			'fetchUpcomingTrips',
		);
	};
